export default __webpack_public_path__ + "static/media/24.f939bb6b.jpg";